import {MaterialTopTabScreenProps} from '@react-navigation/material-top-tabs';
import {ParamListBase} from '@react-navigation/native';
import React from 'react';

import {Page} from './contentful';

interface ScreenProps extends MaterialTopTabScreenProps<ParamListBase> {}

export const TabPage: React.FC<ScreenProps> = ({route}) => {
  const screenName = route.name;

  return <Page {...{screenName}} />;
};
